function domainInfo(state = "", action) {
    switch (action.type) {
      case "SET_DOMAIN_INFO":
        return action.value;
      default:
        return state;
    }
  }
  export default domainInfo;